'use strict';

module.exports = {
    SIGN: 'Đăng nhập',
    SIGN_JOIN: 'Đăng nhập hoặc Tham gia miễn phí!',
    EMAIL_EXISTS: 'Email này đã tồn tại.',
    INVALID_EMAIL: 'Vui lòng nhập địa chỉ Email hợp lệ',
    INVALID_FIRST_NAME: 'Vui lòng nhập Tên hợp lệ',
    INVALID_LAST_NAME: 'Vui lòng nhập Họ hợp lệ',
    INVALID_PASSWORD: 'Vui lòng nhập 6 - 20 ký tự (chỉ gồm AZ, az, 0-9)',
    INVALID_REPASSWORD: 'Mật khẩu không giống nhau',
    INVALID_VALID_CODE: 'Vui lòng nhập Mã hợp lệ',
    UNAVIALABLE_SERVICE: 'Dịch vụ chưa sẵn sàng, vui lòng thử lại lần sau.',
    EMPTY_VALID_CODE: 'Nhập các ký tự bạn nhìn thấy trong hình',
    NOT_MEMBER: 'Không phải là thành viên?',
    ALREADY_MEMBER: 'Đã là thành viên AliExpress/Alibaba?',
    EMAIL: 'Địa chỉ email',
    CONTACT_NAME: 'Tên người liên hệ:',
    FIRST_NAME: 'Tên',
    LAST_NAME: 'Họ',
    PASSWORD: 'Mật khẩu',
    REPASSWORD: 'Nhập lại Mật khẩu:',
    EMPTY_CODE: 'Nhập Mã số hiển thị:',
    REFRESH: 'Làm mới',
    CREATE_MY_ACCOUNT: 'Tạo tài khoản của tôi',
    NAME: 'Tên',
    VERIFICATION: 'Mã xác nhận',
    AGREE_MENT: 'Xác nhận tài khoản này, bạn đồng ý với',
    AE_MEMBER_SHIP: 'AliExpress.com Miễn phí Thành viên',
    AND: 'và',
    PRIVACY_POLICY: 'Chính sách bảo mật',
    SLIDE_SUBMIT: 'Trượt sang phải để xác minh',
    SLIDE_SUBMIT_TIPS: 'Sự thành công',
    LOADING: 'Đang tải',
    SLIDE_SUBMIT_ERROR_TIPS: 'Trượt sang phải để xác minh',
    SHOP_NOW: 'MUA SẮM NGAY',
    SIGN_IN: 'Đăng nhập',
    REGISTER_SMS: 'Đăng ký bằng SMS',
    REGISTER_EMAIL: 'Đăng ký bằng địa chỉ Email',
    PHONE_NUMBER: 'Số điện thoại',
    VALID_NUMBER: 'Vui lòng nhập một số điện thoại hợp lệ.',
    SEND_SMS_CODE: 'Gửi mã SMS',
    SMS_POLICY: 'Chúng tôi sẽ gửi mã xác thực qua tin nhắn SMS đến số điện thoại bạn đã nhập. Hãy chắc chắn rằng mã quốc gia và số điện thoại đều chính xác.',
    SEND_TO: 'Chúng tôi đã gửi mã đến',
    VERIFICATION_RECEIVED: 'Nhập mã xác thực bạn đã nhận được hoặc',
    EDIT_NUMBER: 'sửa lại số.',
    RESEND_CODE: 'Gửi lại mã',
    LAST_STEP: 'Bước cuối cùng',
    SET_SIGN_IN_PASSWORD: 'Vui lòng đặt một mật khẩu Đăng nhập để tài khoản của bạn an toàn hơn.',
    INVALID_PHONE_PASSWORD: '6-20 ký tự (chỉ gồm chữ và số)',
    NOT_CORRECT_CODE: 'Mã không chính xác, vui lòng thử lại.',
    SAVE_PASSWORD: 'Lưu mật khẩu',
    NO_RECEIVED_CODE: 'Nếu bạn vẫn chưa nhận được mã, hãy thử',
    VIA_EMAIL: 'Đăng ký qua Email'
};